import { styled } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'
import { FooterContainer as HomeFooter } from '../../HomePage/HomePageUI.styles'

export const CoveredContainer = styled.div`
  width: 100%;
  margin-top: 12px;

  ${onMediumScreen()} {
    margin-top: 90px;
  }
`

export const FooterContainer = styled(HomeFooter)`
  margin-bottom: 20px;
`

export const Divider = styled.div`
  width: calc(100% - 40px);
  height: 2px;
  background-color: ${({ theme }) => theme.colors.grayAccent};

  ${onMediumScreen()} {
    width: 100%;
  }
`
